import { Entity, PrimaryGeneratedColumn, Column, ManyToMany, JoinTable, OneToMany } from "typeorm"
import { PaygUser } from "./PaygUser"
import { PaygTransaction } from "./PaygTransaction"
import { bigint } from "../../transofrmers/BigInt"

@Entity("payg_ev_charger")
export class PaygEvCharger {
    @PrimaryGeneratedColumn({ name: "id" })
    id?: number

    @Column({ nullable: false })
    iccid?: string

    @Column({ nullable: false, type: "float" })
    credit?: number

    @ManyToMany(() => PaygUser, user => user.paygDetails)
    @JoinTable()
    users?: PaygUser[]

    @OneToMany(() => PaygTransaction, transaction => transaction.EvCharger)
    transactions?: PaygTransaction[]

    @Column({ type:'datetime', nullable:true, default:null })
    lastCycleTimestamp?: Date

    @Column({ type: "bigint", transformer:bigint, default:0 })
    lastCycleUsage?: number

    @Column({ type: "bigint", transformer:bigint, default:0 })
    initialAllowance?: number
}

